'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import NavSidebar from '@/components/NavSidebar';
import { createArc } from '@/lib/actions';

export default function NewStoryboardPage() {
  const router = useRouter();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const fd = new FormData(e.currentTarget);
    const id = await createArc(fd);
    router.push(`/storyboards/${id}`);
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex">
      <NavSidebar activePath="/storyboards" />

      <main className="flex-1 p-8 overflow-y-auto">
        <div className="max-w-xl">
          <h2 className="text-4xl font-serif font-bold text-white mb-2 italic">New Story Arc</h2>
          <p className="text-slate-400 italic mb-8">Begin a new chapter of your world's story.</p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-xs font-mono uppercase tracking-widest text-slate-400 mb-2">
                Arc Title
              </label>
              <input
                name="title"
                required
                placeholder="e.g. The Fall of Zrada"
                className="w-full bg-slate-900 border border-slate-700 rounded-xl px-4 py-3 text-slate-200 focus:outline-none focus:border-purple-500/50"
              />
            </div>

            <div>
              <label className="block text-xs font-mono uppercase tracking-widest text-slate-400 mb-2">
                Summary
              </label>
              <textarea
                name="summary"
                rows={5}
                placeholder="What is this arc about?"
                className="w-full bg-slate-900 border border-slate-700 rounded-xl px-4 py-3 text-slate-200 focus:outline-none focus:border-purple-500/50 resize-y"
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="px-8 py-3 bg-purple-600 hover:bg-purple-500 disabled:opacity-50 rounded-xl font-bold transition-colors"
            >
              {submitting ? 'Creating...' : 'Create Arc'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
